import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useLocation } from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import ExternalPolicyVerification from '@/components/PersonInsurancePolicy/ExternalPolicyVerification';
import InsuranceVOB from '@/components/PersonInsurancePolicy/InsuranceVOB';
import { InsurancePolicy } from '@/types/insurancePolicy';
import Card from '@/ui/components/Card';
import Container from '@/ui/components/Container';
import Heading from '@/ui/components/Heading';

const InsuranceVOBHistory = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const insurancePolicy = state?.insurancePolicy as InsurancePolicy;
  const { verifications, external_policy_verifications, provider_name } = insurancePolicy;

  return (
    <Container type="page">
      <div className="inline-flex items-center">
        <button
          className="w-6 inline-block text-center mb-1"
          onClick={() => navigate(-1)}
          type="button">
          <FontAwesomeIcon icon={faChevronLeft} className="mr-1 text-xl" />
        </button>
        <PageHeader headingText={`${provider_name} VOB History`} />
      </div>
      <Card>
        <Heading value={4} text="Insurance Policy Verifications" />
        {verifications &&
          verifications.map((insuranceVerification) => (
            <InsuranceVOB
              key={insuranceVerification.id}
              insuranceVerification={insuranceVerification}
            />
          ))}
      </Card>
      <Card>
        <Heading value={4} text="External Insurance Policy Verifications" />
        {external_policy_verifications &&
          external_policy_verifications.map((externalPolicyVerification) => (
            <div
              key={externalPolicyVerification.id}
              className="border-solid border border-gray-200 rounded-lg p-2 m-2">
              <ExternalPolicyVerification externalPolicyVerification={externalPolicyVerification} />
            </div>
          ))}
      </Card>
    </Container>
  );
};

export default InsuranceVOBHistory;
